import { TOOLS_PAGE_TITLE } from '@/constants/pageTitlesAndDescriptionConstants';
import { useOrganizationId } from '@/hooks/useSwr';
import { appOrganizationPath } from '@/utils/constants';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function ToolsCrumb(props: Partial<BreadcrumbData>) {
  const organizationId = useOrganizationId();

  return (
    <Breadcrumb
      name={props.condensed ? '' : TOOLS_PAGE_TITLE}
      path={`/${appOrganizationPath}/${organizationId}/tools`}
      {...props}
    />
  );
}
